'use client';

import { OraclePriceData } from '@velocity-exchange/sdk';
import { MarketId } from '@velocity-exchange/common';
import { useCallback } from 'react';
import useMarketStateStore from '../stores/useMarketStateStore';

/**
 * Returns a function to get full OraclePriceData (SDK BN type) for any market.
 * Reads from useMarketStateStore which is kept fresh by the orderbook subscription.
 * TODO: move to react query
 */
const useGetRawOracleDataForMarket = () => {
	const getRawOracleData = useMarketStateStore(
		(s) => s.getRawOracleDataForMarket
	);

	return useCallback(
		(marketId: MarketId): OraclePriceData | undefined => {
			return getRawOracleData(marketId);
		},
		[getRawOracleData]
	);
};

export default useGetRawOracleDataForMarket;
